// assets
import colors from 'assets/scss/_themes-vars.module.scss';

export const themeLight = {
    active: {
        heading: colors.grey900,
        paper: colors.paper,
        defaultBg: colors.paper,
        backGround: colors.primaryLight,
        darkTextPrimary: colors.grey700,
        primaryLight: colors.primaryLight,
        secondaryLight: colors.primary200,
        secondaryDark: colors.secondaryDark,
        darkTextSecondary: colors.grey500,
        textDark: colors.grey900,
        secondary800: colors.secondary800,
        warningLight: colors.warningLight,
        secondaryMain: colors.secondaryMain,
        grey50: colors.darkBackground,
        secondary200: colors.secondary200,
        grey500: colors.grey500,
        grey5002: colors.grey500,
        grey999: colors.grey999,
        grey100: colors.grey100,
        menuSelected: colors.secondaryDark,
        menuSelectedBack: colors.secondaryLight,
        divider: colors.grey200,
    },
};

export default themeLight;
